import { cn } from '../../lib/utils';

const KNOWN_STATUSES: Record<string, { label: string; dot: string }> = {
  paid: { label: 'ОПЛАЧЕНО', dot: 'bg-accent' },
  pending: { label: 'ОЧІКУЄ ОПЛАТИ', dot: 'bg-warn' },
  failed: { label: 'ОПЛАТА НЕ ПРОЙШЛА', dot: 'bg-warn' },
  cod: { label: 'ОПЛАТА ПРИ ОТРИМАННІ', dot: 'bg-muted' },
};

export function PaymentStatusBadge({ paymentStatus }: { paymentStatus: string }) {
  const entry = KNOWN_STATUSES[paymentStatus] ?? {
    label: paymentStatus.toUpperCase(),
    dot: 'bg-muted',
  };

  return (
    <span className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.12em] text-muted">
      <span className={cn('h-[7px] w-[7px] rounded-full', entry.dot)} />
      {entry.label}
    </span>
  );
}
